import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

const ENDPOINT = "cierres_mensuales_inventario";

export const CierreMensualApi = () => {
    const [cargando, setCargando] = useState(false);

    const getPeriodosACerrar = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                `${ENDPOINT}/periodos_a_cerrar`,
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getLimitesCorte = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                `${ENDPOINT}/limites_corte`,
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getEstadoPeriodo = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(`${ENDPOINT}/estado_periodo`, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // lo que se va a registrar, antes de registrarlo: solo la mitad del formato
    // que le toca al tipo elegido
    const getPrevisualizacion = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                `${ENDPOINT}/previsualizacion`,
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const registrarCierreMensual = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(ENDPOINT, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getPeriodosACerrar,
        getLimitesCorte,
        getEstadoPeriodo,
        getPrevisualizacion,
        registrarCierreMensual,

        cargando,
    };
};
